module.exports = __webpack_public_path__ + "static/media/biopharmachemireland.e7db0c10.png";